module.exports = __webpack_public_path__ + "img/el-ic-sticker.3be7e650.svg";